/**
 * @description 发送记录列表表格列头配置
 * @returns {Array} 表格列配置数组
 */
export default function () {
  /* 表格列头配置 */
  return [
    // 序号列
    { label: "序号", type: "index", width: 80 },

    // 发送状态（成功/失败）
    { label: "发送状态", prop: "send_status", slots: "send_status", minWidth: 100 },

    // 所属公众号
    { label: "所属公众号", prop: "account_name", minWidth: 100 },

    // 消息模版ID
    { label: "模版ID", prop: "template_id", minWidth: 150, slots: "template_id" },

    // 用户公众号openid
    { label: "发送对象", prop: "user_name", width: 100, slots: "user_name", },

    // 发送方式（自动/手动）
    { label: "发送方式", prop: "send_way", slots: "send_way", minWidth: 100 },

    // 发送结果回调信息
    { label: "发送结果", prop: "callback_msg", minWidth: 200 },

    // 发送时间
    {
      label: "发送时间",
      prop: "create_time",
      width: 180
    },

    // 操作列
    {
      label: "操作",
      prop: "operation",
      width: 60,
      slots: "operation",
      fixed: "right"
    }
  ];
}
